"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppConfig = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _constants = require("../../common/constants");
var useAppConfig = function useAppConfig() {
  for (var _len = arguments.length, path = new Array(_len), _key = 0; _key < _len; _key++) {
    path[_key] = arguments[_key];
  }
  var appConfig = (0, _reactSdk.useHMSStore)(_reactSdk.selectAppDataByPath.apply(void 0, [_constants.APP_DATA.appConfig].concat(path)));
  return appConfig;
};
exports.useAppConfig = useAppConfig;